import type { ReportingMonetizationTier } from '@cast/types';

type ReportingTrialDevOverrideState =
  | 'pre-trial'
  | 'active'
  | 'grace-period'
  | 'post-trial'
  | 'paid';

type ReportingTrialDevOverrideHooks = {
  useReportingTrialStateOverride: () =>
    | ReportingTrialDevOverrideState
    | undefined;
  useReportingTrialEligibleOverride: () => boolean | undefined;
  useReportingTrialTierOverride: () => ReportingMonetizationTier | undefined;
};

const noOverride = () => undefined;

let hooks: ReportingTrialDevOverrideHooks = {
  useReportingTrialStateOverride: noOverride,
  useReportingTrialEligibleOverride: noOverride,
  useReportingTrialTierOverride: noOverride,
};

/**
 * Called from the app layer (Dev Toolbox) to inject override hooks.
 * Must be invoked at module load before any `useReportingTrial` calls.
 */
export const configureReportingTrialDevOverrides = (
  next: Partial<ReportingTrialDevOverrideHooks>
) => {
  hooks = {
    useReportingTrialStateOverride:
      next.useReportingTrialStateOverride ??
      hooks.useReportingTrialStateOverride,
    useReportingTrialEligibleOverride:
      next.useReportingTrialEligibleOverride ??
      hooks.useReportingTrialEligibleOverride,
    useReportingTrialTierOverride:
      next.useReportingTrialTierOverride ?? hooks.useReportingTrialTierOverride,
  };
};

export const useReportingTrialStateDevOverride = () =>
  hooks.useReportingTrialStateOverride();

export const useReportingTrialEligibleDevOverride = () =>
  hooks.useReportingTrialEligibleOverride();

export const useReportingTrialTierDevOverride = () =>
  hooks.useReportingTrialTierOverride();
